<!--
  @Description 日期选择框
  @Date 2021-12-31
  @Author liushuo
-->
<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    title="日期输入框"
    width="300px"
    mask-closable
    @show="showModal"
  >
    <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
      <el-form-item prop="date">
        <el-date-picker
          v-model="form.date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <el-button @click="handleCommit" style="float: right; margin-top: 10px" size="mini" type="primary">确认</el-button>
  </vxe-modal>
</template>
<script>
export default {
  name: 'DateInput',
  props: {},
  data() {
    return {
      formVisible: false,
      form: {
        date: ''
      },
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'change' }]
      },
      // 是否限制当天之后时间不能选择
      isLimitToday: true,
      // 日期选择框配置项
      pickerOptions: null
    }
  },
  methods: {
    showModal() {
      this.form.date = ''

      this.setPickerOptions()

      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    // 日期选择框配置
    setPickerOptions() {
      // 不限制未来日期可选
      if (!this.isLimitToday) {
        this.pickerOptions = {
          // 注意！不能返回 pickerOptions 空对象，必须加上 disabledDate 函数来返回 Boolean 才会生效
          disabledDate: () => {
            return false
          }
        }
      } else {
        // 限制不能选择今天之后的日期(已测试用该方法限制，不会存在偏差8小时的问题)
        this.pickerOptions = {
          disabledDate: time => {
            return time.getTime() > Date.now()
          }
        }
      }
    },
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        return
      }
      const selectDate = this.ykDateFormat('yyyy-MM-dd', this.form.date)
      this.$emit('sureHandler', selectDate)
      this.$nextTick(() => {
        this.formVisible = false
      })
    },
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      return flag
    }
  }
}
</script>
<style lang="less" scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
/deep/ .el-date-editor {
  width: 100%;
}
.el-form-item {
  margin: 0;
}
</style>
